import React from "react";

function ShowError({ messge = "Some of the information is missing" }) {
  return (
    <div>
      <h3>Error!!! {messge}</h3>
    </div>
  );
}

export default ShowError;
